import styled from 'styled-components';
import { ModalCloseButton as VHSModalCloseButton } from '@wistia/vhs';

export const ModalCloseButton = styled(VHSModalCloseButton)`
  background-color: #ffffff;
`;
